import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { APPINSTALLATIONS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const AppInstallationsService = ComposedComponent =>
  reduxFetch([
    {
      resource: APPINSTALLATIONS_RESOURCE,
      method: 'get',
      request: t => ({
        url: apiRoutes.appInstallations(),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppInstallationsFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AppInstallationsService;
